var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72055 2.59156C10.5954 -0.0643721 14.4046 -0.0643755 15.2794 2.59156L16.1088 5.10924C16.5 6.29701 17.6221 7.1012 18.8882 7.1012H21.5719C24.403 7.1012 25.5801 10.6747 23.2897 12.3162L21.1185 13.8722C20.0942 14.6063 19.6656 15.9075 20.0569 17.0952L20.8862 19.6129C21.761 22.2689 18.6793 24.4774 16.389 22.836L14.2178 21.28C13.1935 20.5459 11.8065 20.5459 10.7822 21.28L8.61104 22.836C6.32065 24.4774 3.23895 22.2689 4.1138 19.6129L4.94311 17.0952C5.33436 15.9075 4.90575 14.6063 3.88146 13.8722L1.71029 12.3162C-0.580096 10.6747 0.597006 7.1012 3.42808 7.1012H6.11179C7.37789 7.1012 8.5 6.29702 8.89124 5.10925L9.72055 2.59156Z",
    fill: "#8086B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotlight);
export default __webpack_public_path__ + "static/media/spotlight.d8cf897c.svg";
export { ForwardRef as ReactComponent };